import LayoutPage from '@components/LayoutPage';
import { get404Props } from '@lib/fetch/getStaticProps';
import type { NextPage } from 'next';

const NotFound: NextPage = () => <LayoutPage />;
export const getStaticProps = get404Props;

export default NotFound;
